import React, { useContext } from 'react';
import { Router } from '@reach/router';
import { Query } from 'react-apollo';

import { GET_FARM_ID_BY_EDE } from '../graphql/queries';
import UserContext from '../context';
import BreederHome from '../organisms/BreederHome';
import HeiferDetails from '../organisms/HeiferDetails';
import BreederTransfers from '../organisms/BreederTransfers';
import PoolDelegationDetails from '../organisms/PoolDelegationDetails';
import PoolReturnDetails from '../organisms/PoolReturnDetails';
import Loader from '../atoms/Loader';

const Breeder = () => {
  const { username } = useContext(UserContext);
  const ede = username.attributes['custom:ede_number'];

  return (
    <Query query={GET_FARM_ID_BY_EDE} variables={{ ede }} skip={!ede}>
      {({ loading, error, data }) => {
        if (loading) return <Loader />;
        if (error) throw new Error(error.message);
        const { farm } = data;

        return (
          <Router primary={false}>
            <BreederHome path="/" farmId={farm.id} />
            <HeiferDetails path="heifer/:heiferId" />
            <BreederTransfers
              path="transfer/delegations"
              farmId={farm.id}
              type="DELEGATION"
            />
            <BreederTransfers
              path="transfer/returns"
              farmId={farm.id}
              type="RETURN"
            />
            <PoolDelegationDetails path="transfer/delegations/:poolId" />
            <PoolReturnDetails path="transfer/returns/:poolId" />
          </Router>
        );
      }}
    </Query>
  );
};

export default Breeder;
